<template>
  <div class="wrap" >
    <!-- 登录 -->
    <div v-if="loginOrReginter" id="login" class="login-box" >
      <!-- 关闭 -->
      <div class="close" @click="closeLogin">
        <img src="/static/images/icon_delete.png" alt="">
      </div>
      <div class="login-tab g-flex flex-betn">
        <div class="tab" :class="{ active: loginTab == 1 }" @click="loginTabChange(1)">密码登录</div>
        <div class="tab" :class="{ active: loginTab == 2 }" @click="loginTabChange(2)">短信登录</div>
      </div>
      <el-form
        v-if="loginTab == 1"
        :model="loginForm"
        status-icon
        ref="loginForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item prop="phone">
          <el-input
            type="text"
            v-model="loginForm.phone"
            autocomplete="off"
            placeholder="请输入邮箱/手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="no-account g-flex flex-betn" style="height: auto;line-height: 20px;">
            <p class="left g-flex flex-center">
              没有账号？
              <span @click="toRegister">立即注册</span>
              <span class="icon"></span>
            </p>
            <p class="right">忘记密码？</p>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            @click="submitForm('loginForm')"
            style="width:100%; background-color:#e60012;"
          >登录</el-button>
        </el-form-item>
      </el-form>
      <el-form
        v-else
        :model="msgForm"
        status-icon
        ref="msgForm"
        label-width="0px"
        class="msg-form"
      >
        <el-form-item prop="phone">
          <el-input type="text" v-model="msgForm.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="phone_code">
          <div class="pass g-flex">
            <el-input
              type="password"
              v-model="msgForm.phone_code"
              autocomplete="off"
              placeholder="请输入验证码"
            ></el-input>
            <el-button :disabled="disabled" @click="loginSendMsg">
              {{
              disabled ? count + 's' : '点击获取验证码'
              }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            @click="submitForm('msgForm')"
            style="width:100%; background-color:#e60012;"
          >登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 注册 -->
    <div v-else id="register" class="register" >
      <!-- 关闭 -->
      <div class="close" @click="closeLogin">
        <img src="/static/images/icon_delete.png" alt="">
      </div>
      <el-form
        :model="registerForm"
        status-icon
        :rules="registerRules"
        ref="registerForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item prop="phone">
          <el-input
            type="text"
            v-model="registerForm.phone"
            autocomplete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="code g-flex">
            <el-input
              type="text"
              v-model="registerForm.phone_code"
              autocomplete="off"
              placeholder="请输入验证码"
            ></el-input>
            <el-button :disabled="disabled" @click="sendMsg">
              {{
              disabled ? count + 's' : '点击获取验证码'
              }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="registerForm.password"
            autocomplete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirm">
          <el-input
            type="password"
            v-model="registerForm.confirm"
            autocomplete="off"
            placeholder="请确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input
            type="text"
            v-model="registerForm.name"
            autocomplete="off"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="agreement">
            <el-checkbox v-model="agreementChecked">我已阅读并同意协议</el-checkbox>
            <el-button type="text" @click="toAgreement">《协议》</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="resDisabled"
            type="danger"
            @click="submitForm('registerForm')"
            style="width:100%; background-color:#e60012;"
          >注册</el-button>
        </el-form-item>
        <div class="g-flex flex-end">
          <el-button type="text" @click="toLogin" style="padding:0;marign:0;">已有账号，去登陆</el-button>
        </div>
      </el-form>
    </div>
    
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
  postLogin,
  postReg,
  postRegSms,
  postMsgLogin,
  postMsgLoginCheck
} from '@/api/main.js'
export default {
  components: {},
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱/手机号'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {
      count: 60, //倒计时
      disabled: false, //验证码按钮禁用
      loginTab: 1, //1--密码登陆2---短信登陆
      loginForm: {
        phone: '',
        password: ''
      },
      msgForm: {
        phone: '',
        phone_code: ''
      },
      loginRules: {
        user: [
          {
            validator: validateUser,
            trigger: 'blur'
          }
        ],
        pass: [
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ]
      },
      agreementChecked: false, //同意协议
      resDisabled: false, //注册按钮是否禁用
      registerForm: {
        phone: '',
        phone_code: '', //验证码
        password: '', //密码
        confirm: '', // 确认密码
        name:''
      },
      registerRules: {}
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      toRouter: state => state.toRouter,
      formVisible: state => state.formVisible,
      loginOrReginter: state => state.loginOrReginter
    })
  },
  watch: {
    formVisible: {
      handler(newVal) {
        if (!newVal) {
          // 重置为密码登录页面
          setTimeout(() => {
            this.loginTab = 1
            this.setLoginOrReginter(true)
            this.resetForm()
          }, 300)
        }
      },
      immediate: true
    },
    agreementChecked: {
      handler(newVal) {
        if (newVal) {
          this.resDisabled = false
        } else {
          this.resDisabled = true
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations([
      'setLogin',
      'setLoginOrReginter',
      'setFormVisible',
      'setTabActive',
      'setToken'
    ]),
    // 登录
    submitForm(type) {
      // 账号密码登录
      if (type == 'loginForm') {
        postLogin(this.loginForm).then(res => {
          if (res.data.code == 200) {
            this.$cookies.set('muou_token', res.data.data)

            this.setToken(res.data.data)
            this.overLogin('登录成功')
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      }
      // 注册
      if (type == 'registerForm') {
        var query = {}
        query.phone = this.registerForm.phone
        query.phone_code = this.registerForm.phone_code
        query.password = this.registerForm.password
        query.name = this.registerForm.name
        postReg(query).then(res => {
          if (res.data.code == 200) {
            this.overLogin('注册成功')
          } else {
            if (res.data.code == 400) {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }
        })
      }
      // 短信验证码登录
      if (type == 'msgForm') {
        postMsgLogin(this.msgForm).then(res => {
          if (res.data.code == 200) {
            this.$cookies.set('muou_token', res.data.data)
            this.setToken(res.data.data)
            this.overLogin('登录成功')
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      }
    },
    // 登录完成
    overLogin(msg) {
      this.$message({
        message: msg,
        type: 'success'
      })
      this.setLogin(true)
      this.setFormVisible(false)
      this.setTabActive('')
      if (this.toRouter && this.toRouter !== '') {
        this.$router.push(this.toRouter)
      }
    },
    // 去注册
    toRegister() {
      this.setLoginOrReginter(false)
    },
    toLogin() {
      this.setLoginOrReginter(true)
    },
    //密码登录和短信登录切换
    loginTabChange(e) {
      this.loginTab = e
    },
    // 注册发送验证码信息
    sendMsg() {
      if (this.registerForm.phone !== '') {
        postRegSms({ phone: this.registerForm.phone }).then(res => {
          if (res.data.code == 200) {
            this.countDown()
          }
          if (res.data.code == 400) {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      }
    },
    // 短信登录页面发送验码
    loginSendMsg() {
      if (this.msgForm.phone !== '') {
        postMsgLoginCheck({ phone: this.msgForm.phone }).then(res => {
          if (res.data.code == 200) {
            this.countDown()
          }
          if (res.data.code == 400) {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      }
    },
    // 60s
    countDown() {
      this.disabled = true
      var timer = setInterval(() => {
        if (this.count > 0) {
          this.count--
        } else {
          clearInterval(timer)
          this.count = 10
          this.disabled = false
        }
      }, 1000)
    },
    // 跳转协议页面
    toAgreement() {
      this.$router.push('/agreement')
      this.setFormVisible(true)
    },
    // 关闭登录
    closeLogin() {
      this.setFormVisible(false)
    },
    // 重置表单为空
    resetForm() {
      this.loginForm = {
        phone: '',
        password: ''
      }
      this.msgForm = {
        phone: '',
        phone_code: ''
      }
      this.registerForm = {
        phone: '',
        phone_code: '', //验证码
        password: '', //密码
        confirm: '', // 确认密码
        name:''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* pc */
#login,
#register {
  width: 500px;
  padding: 80px 100px;
  border-radius: 4px;
  background-color: #fff;
  color: #999;
  position: relative;
  > .close {
    position: absolute;
    width: 12px;
    height: 12px;
    top: 10px;
    right: 10px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

#login .no-account {
  color: #999;
}

#login .no-account .left span {
  color: #8f9fbc;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
}

#login .no-account .left .icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

#login .no-account .right {
  user-select: none;
  color: #8f9fbc;
  cursor: pointer;
}

#login .login-tab {
  width: 100%;
  padding: 0 10px;
  margin-bottom: 17px;
}

#login .login-tab .tab {
  width: 100px;
  text-align: center;
  padding: 15px 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

#login .login-tab .tab.active {
  border-bottom: 2px solid #e90012;
}

#login .msg-form .pass .el-input {
  width: 178px;
  margin-right: 10px;
}

#login .msg-form .pass .el-button {
  flex: 1;
  font-size: 12px;
}

#register .code .el-input {
  width: 178px;
  margin-right: 10px;
}

#register .code .el-button {
  flex: 1;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue